module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    style: ({
      transform: ("translateY(" + _vm.translate + "px)"),
      transition: _vm.transition
    })
  }, [_c('div', {
    staticClass: "spinner"
  }, [_c('mt-spinner', {
    attrs: {
      "type": "snake",
      "color": "#ff6b65",
      "size": _vm.spnsize
    }
  })], 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6aeb8ed2"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/content/pulldown.vue
// module id = 210
// module chunks = 1